import React from 'react';
import styles from './DateRangePicker.module.css';

const DEFAULT_PERIODS = [
  { key: 7, label: '7d' },
  { key: 30, label: '30d' },
  { key: 90, label: '90d' },
];

// Custom dates (both set) win over the preset period. Same timezone-safe
// construction as Events.jsx's periodRange() — appending an explicit local
// time-of-day (no Z/offset) makes both bounds parse in the browser's local
// timezone, so a picked date's full day (not just from UTC midnight) is
// included, regardless of the admin's timezone relative to UTC.
function periodRange(period, customFrom, customTo) {
  if (customFrom && customTo) {
    const from = new Date(customFrom + 'T00:00:00');
    const to = new Date(customTo + 'T23:59:59.999');
    return { from: from.toISOString(), to: to.toISOString() };
  }
  const to = new Date();
  const from = new Date(to.getTime() - period * 24 * 60 * 60 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
}

// Self-contained date range control — manages its own period/custom-date
// state and calls onChange({from, to}) on mount and on every change, so a
// page just drops this in and re-fetches in that callback. See Events.jsx
// for the page that originated this exact pattern (kept independent there
// rather than retrofitted, to avoid touching an already-working page).
class DateRangePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { period: props.defaultPeriod || 30, customFrom: '', customTo: '' };
  }

  componentDidMount() {
    this._notify();
  }

  _notify() {
    const { period, customFrom, customTo } = this.state;
    this.props.onChange(periodRange(period, customFrom, customTo));
  }

  selectPeriod(days) {
    // Picking a preset implicitly wins over a custom range already — clear
    // it here so choosing a preset doesn't leave a contradictory-looking UI.
    this.setState({ period: days, customFrom: '', customTo: '' }, () => this._notify());
  }

  setCustom(key, value) {
    this.setState({ [key]: value }, () => this._notify());
  }

  render() {
    const { period, customFrom, customTo } = this.state;
    const periods = this.props.periods || DEFAULT_PERIODS;

    return (
      <div className={styles.wrap}>
        <div className={styles.periodGroup}>
          {periods.map((p) => (
            <button
              key={p.key}
              className={[styles.periodBtn, period === p.key && !customFrom && !customTo ? styles.periodOn : ''].join(' ')}
              onClick={() => this.selectPeriod(p.key)}
            >
              {p.label}
            </button>
          ))}
        </div>
        <div className={styles.dateRange}>
          <input
            type="date"
            className={styles.dateInput}
            value={customFrom}
            onChange={(e) => this.setCustom('customFrom', e.target.value)}
          />
          <span className={styles.dateSep}>–</span>
          <input
            type="date"
            className={styles.dateInput}
            value={customTo}
            onChange={(e) => this.setCustom('customTo', e.target.value)}
          />
        </div>
      </div>
    );
  }
}

export default DateRangePicker;
